export default __webpack_public_path__ + "static/media/crypto070.06b89511.gif";